import styled from 'styled-components'
import { Checkbox } from 'semantic-ui-react'

export const StyledCheckbox = styled(Checkbox)`
  &&& {
    display: flex;
    justify-content: flex-start;
  }
`
